export const LISTE_COLLECTIVITE = {
  title: 'Liste des collectivités TLPE',
  breadcrumb: {
    racine: 'Accueil',
    listeCollectivite: 'Liste des collectivités TLPE',
  },
  actions: {
    new: 'Nouvelle collectivité TLPE',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    ville: 'Ville(s)',
    nom: 'Nom collectivité',
    collectivites: 'Collectivité(s)',
    adresse: 'Adresse',
    departement: 'Département',
    email: 'Email',
    telephone: 'Téléphone',
    compteComptable: 'Compte(s) comptable',
    archiver: 'Archivé',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  tab: {
    code: 'Code',
    nomCommercial: 'Nom commercial',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    nom: 'Nom collectivité',
    telephone: 'Téléphone',
    email: 'Email',
    compteComptable: 'Compte comptable',
    actions: {
      edit: 'Modifier',
      archive: 'Archiver',
      delete: 'Supprimer',
    },
  },
};

export const ARCHIVER_COLLECTIVITE = {
  archive: 'Etes-vous sûr de vouloir archiver cette collectivité ?',
  desarchive: 'Etes-vous sûr de vouloir désarchiver cette collectivité ?',
  archiveContacts: 'L\'archivage de la collectivité entraînera également l\'archivage de ses contacts.',
  archiveSuccess: 'Collectivité archivée avec succès.',
  desarchiveSuccess: 'Collectivité désarchivée avec succès.',
};

export const AJOUT_EDITION_COLLECTIVITE = {
  creation: 'Créer une collectivité TLPE',
  edition: 'Modifier collectivité TLPE {nomCommercial}',
  problemOccurred: 'Un problème est survenu',
  actions: {
    annuler: 'Annuler',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeCollectivite: 'Liste des collectivités TLPE',
    addCollectivite: 'Création une collectivité TLPE',
    editCollectivite: 'Modifier une collectivité TLPE',
  },
  generalInformations: {
    title: 'Informations générales',
    estMairie: 'Mairie',
    nameCollectivite: 'Nom de la collectivité TLPE',
    compteComptable: 'Compte comptable',
    applicationTva: 'Application TVA',
  },
  adresse: {
    title: 'Adresse',
    postalAddress: 'Adresse postale',
  },
  infoComptable: {
    title: 'Informations comptables',
  },
  paiement: {
    title: 'Informations règlements / facturation',
  },
  contact: {
    title: 'Contacts',
  },
  error: {
    nomCollectivite: 'Nom de la collectivité TLPE',
  },
  messages: {
    successCreation: 'Création de la collectivité TLPE réalisée avec succès.',
    successChange: 'Modification de la collectivité TLPE réalisée avec succès.',
  },
};

export const DETAIL_COLLECTIVITE = {
  title: 'Détail collectivité TLPE {nomCommercial}',
  onglet: {
    collectivite: 'Collectivité',
    commandeTlpe: 'Déclaration TLPE',
    titreRecetteCollectivite: 'Titre de recette',
    encoursCollectivite: 'Encours collectivité',
    compteCollectivite: 'Compte',
  },
  actions: {
    cancel: 'Retour',
    edit: 'Modifier',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeCollectivite: 'Liste des collectivités TLPE',
    detailCollectivite: 'Détail collectivité TLPE',
  },
  steps: {
    infoGenerales: 'Informations générales',
    informationComptable: 'Information comptable',
    contacts: 'Contacts',
    piecesJointes: 'Pièces jointes',
  },
  informationsGenerales: {
    title: 'Informations générales',
  },
  infoCompta: {
    title: 'Information comptable',
  },
  contact: {
    title: 'Contacts',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  commandeTlpe: {
    tab: {
      code: 'Code',
      annee: 'Année',
      declarant: 'Déclarant',
      etat: 'Etat',
      typeDeclaration: 'Type de déclaration',
      codeDossier: 'Code dossier',
    },
    filtre: {
      code: 'Code(s)',
      annee: 'Année',
      declarant: 'Déclarant(s)',
      etat: 'Etat(s)',
      typeDeclaration: 'Type(s) de déclaration',
      codeDossier: 'Code(s) dossier',
    },
  },
};

export const DECLARATION_TLPE = {
  title: 'Déclarations TLPE',
  titleAuFilDeLeau: "Déclarations TLPE au fil de l'eau",
  year: 'Année de déclaration',
  breadcrumb: {
    racine: 'Accueil',
    declarationsTLPE: 'Déclarations TLPE',
    declarationsTLPEAuFilDeLeau: "Déclarations TLPE au fil de l'eau",
  },
  actions: {
    generationCommandesTlpe: 'Génération des déclarations Tlpe',
    impressionCommandesTlpe: 'Impression des déclarations Tlpe',
    genererEdition: 'Générer Edition',
    search: 'Rechercher',
    filtre: 'Filtre',
    export: 'Exporter',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    ville: 'Ville(s)',
    nom: 'Nom collectivité',
    adresse: 'Adresse',
    email: 'Email',
    telephone: 'Téléphone',
    compteComptable: 'Compte(s) comptable',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  tab: {
    nomCommercial: 'Nom collectivité',
    compteComptable: 'Compte comptable',
    nbMaterielPresent: 'Matériels déclarable au 01 janv.',
    nbDemontageAnPrec: 'Matériels démontés An-1',
    nbMontageAnPrec: 'Matériels montés An-1',
    nbMaterielMontageND: 'Matériel monté non déclaré',
    nbMaterielDemontageND: 'Matériel démonté non déclaré',
    nbMaterielMontageNDPrevAnnee: 'Matériel monté n-1 non déclaré',
    nbMaterielDemontageNDPrevAnnee: 'Matériel démonté n-1 non déclaré',
    commande: 'Déclaration(s) TLPE',
  },
  listes: {
    declarations: {
      materielPresent: 'Matériels déclarable au 01 janv.',
      montageAnPrec: 'Matériels montés An-1',
      demontageAnPrec: 'Matériels démontés An-1',
      materielMontage: 'Matériels monté',
      materielDemontage: 'Matériels démonté',
    },
  },
  popup: {
    generationCommandeTlpe: {
      title: 'Génération des déclarations Tlpe',
      subTitle: '{nbCollectivite} collectivité(s) pour l\'année {year}',
      declarant: 'Déclarant',
    },
  },
  messages: {
    errors: {
      noProduitReglementTlpe: 'Le produit par défaut des règlements TLPE doit être renseigné dans les paramètres de la société.',
    },
    info: {
      materielParCollectivite: 'Liste des matériels liés à la collectivité "{nom}"',
    },
  },
  edition: {
    declarationsTlpe: 'Déclaration TLPE',
    courrierAccompagnement: 'Courrier d\'accompagnement',
  },
};
